// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1xDPV","topBottomGutter":"Layout_topBottomGutter__2J6X4"};